import React from 'react';
import './ToastNotification.css';

export const CloseNotificationButton = ({ closeToast }) => (
  <i className="togo-icon togo-icon-closes" onClick={closeToast} />
);

export const ToastNotification = props => {
  const { type, title, description } = props;

  return (
    <div className="toast-title">
      {title}
      <br />
      <div className="showProgress">
        <div className="toast-description">{description}</div>
        <div className={`load ${type}`} />
      </div>
    </div>
  );
};

export class DownloadStatusType {
  static get PROGRESSING() {
    return 'progressing';
  }

  static get SUCCESS() {
    return 'success';
  }

  static get FAILURE() {
    return 'failure';
  }
}



// WEBPACK FOOTER //
// ./src/Scss/Custom/ReactToastify/ToastNotification.js